export * from './wordForms'

export const ASYNC_DATA_KEYS = {
  statics: 'statics',
  misList: 'misList',
  logos: 'logos',
  partnersFeaturesTableInfo: 'partnersFeaturesTableInfo'
}
